<template>
  <div class="index">
    <div class="header">
      <div class="choose-school" @click="chooseSchool" v-if="!schoolLock"><span>{{schoolInfo.schoolName}}</span></div>
      <div class="choose-school no-choose" v-else><span>{{schoolInfo.schoolName}}</span></div>
      <div class="to-search" @click="toSearch">
        <span>搜索商家、商品名称</span>
      </div>
    </div>
    <div class="main no-foot">
      <div class="banner" id="banner1">
        <div class="swiper-container" v-if="banners.length>0">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in banners" @click="bannerJump(item.data)" :style="{backgroundImage:'url('+item.imageUrl+')'}"></div>
          </div>
        </div>
        <div class="pagination"></div>
      </div>
      <div v-if="showPage">
        <div class="category-list" v-if="shopCategoryList.length>0">
          <ul>
            <li v-for="item in shopCategoryList">
              <a @click="toShopList(item.id, item.category_name)">
                <span class="icon" :style="item.backgroundimg"></span>{{item.category_name}}
              </a>
            </li>
          </ul>
        </div>
        <div class="goods-list shop">
          <div class="goods-title">本校商家</div>
          <ul>
            <li v-for="item in currentShopList">
              <div class="goods-box">
                <div class="goods-img" @click="toGoodsList(item.id,item.shop_name)">
                  <div class="lazy goodimg" :style="item.backgroundimg"></div>
                </div>
                <div class="goods-des">
                  <div class="name" @click="toGoodsList(item.id,item.shop_name)">{{item.shop_name}}</div>
                  <div class="comment">
                    <CommentStars :qualityCode="item.score"></CommentStars>
                    <span>{{item.score}}</span>
                    <span>月售 {{item.sales}}单</span>
                  </div>
                  <div class="threshold"><span>起送 ￥{{item.threshold_amount}}</span>
                    <span v-if="item.delivery_type == 0">配送 ￥{{item.delivery_fee}}</span>
                    <span v-else>配送 ￥{{item.delivery_fee}} (商家自配送)</span>
                  </div>
                  <!--<div class="des" v-if="item.promotion_list.length>0">-->
                    <!--<span :style="{backgroundImage: 'url('+item.promotion_list[0].icon_url+')'}">{{item.promotion_list[0].promotion_name}}</span>-->
                  <!--</div>-->
                  <div v-if="item.promotion_list.length>0">
                    <div class="more-promotion" v-if="item.promotion_list.length<=2">
                      <div class="des" v-for="p in item.promotion_list">
                        <span :style="{backgroundImage: 'url('+p.icon_url+')'}">{{p.promotion_name}}</span>
                      </div>
                    </div>
                    <div class="more-promotion" v-else>
                      <div v-if="item.isShowAll">
                        <div class="des" v-for="p in item.promotion_list">
                          <span :style="{backgroundImage: 'url('+p.icon_url+')'}">{{p.promotion_name}}</span>
                        </div>
                        <span @click="toggleShowMore(item)" class="shield-more"></span>
                      </div>
                      <div v-else>
                        <div class="des">
                          <span :style="{backgroundImage: 'url('+item.promotion_list[0].icon_url+')'}">{{item.promotion_list[0].promotion_name}}</span>
                        </div>
                        <div class="des">
                          <span :style="{backgroundImage: 'url('+item.promotion_list[1].icon_url+')'}">{{item.promotion_list[1].promotion_name}}</span>
                        </div>
                        <span @click="toggleShowMore(item)" class="show-more"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <span v-if="item.is_open == 1 && item.is_book == 0" class="shop-status">营业中</span>
                <span v-else-if="item.is_open == 1 && item.is_book == 1" class="shop-status can-reserve">可预订</span>
                <span class="shop-status close" v-else>休息中</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {actions} from '../store/actions'
  import CommentStars from '../components/CommentStars'

  export default {
    name: 'index',
    data () {
      return {
        banners: [],
        shopCategoryList: [],
        currentShopList: [],
        currentPage: 1,
        pageSize: 20,
        hasMore: true,
        schoolLock: false,
        showPage: false
      }
    },
    computed: {
      schoolInfo () {
        return this.$store.state.schoolInfo
      },
      wxUid () {
        return this.$store.state.wxUid
      }
    },
    beforeRouteEnter(to, from, next){
      if(from.name=='GoodsList' || from.name=='ShopList') { //GoodsList返回时不刷新，
        to.meta.isBack = true;
      } else {
        to.meta.keepAlive = false;
      }
      next();
    },
    mounted () {
      var _this = this;

      //页面滚动到底部触发事件
      window.onscroll = function () {
        var marginBot = 0
        if (document.documentElement.scrollTop){
            marginBot = document.documentElement.scrollHeight
                -(document.documentElement.scrollTop + document.body.scrollTop)
                - document.documentElement.clientHeight
        } else {
            marginBot = document.body.scrollHeight - document.body.scrollTop - document.documentElement.clientHeight
        }
        if(marginBot <= 0) {
          if(_this.hasMore) {
            _this.getShopList()
          }
        }
      };
    },
    activated () {
      var _this = this;
      document.title = '校内订餐';

      if(!_this.$route.meta.isBack){
        var school_lock = window.localStorage.getItem('school_lock');
        if(school_lock == '1') {
          _this.schoolLock = true
        } else {
          _this.schoolLock = false
        }
        _this.showPage = false;
        _this.banners = [];
        _this.currentPage = 1;
        _this.shopCategoryList = [];
        _this.currentShopList = [];
        document.getElementById('banner1').style.height = '0px';
        _this.getBanner();
        var params = {
          school_id: _this.schoolInfo.schoolId,
          page: 1,
          pageSize: 1000
        };
        // 获取店铺分类列表
        actions.postShopCategoryList(_this, params, function (data) {
          if(data && data.length>0){
            var list = []
            for(let shop of data){
              let obj = {
                backgroundImage: "url("+shop.icon+")"
              }
              shop.backgroundimg = obj
              list.push(shop)
            }
            _this.shopCategoryList = list
          }
          _this.getShopList();
        });
      }
      _this.$route.meta.isBack=false
    },
    methods: {
      getBanner: function (){
        var _this = this
        var url
        let host = _this.$utils.getSpliceHost('adsvc')
//        if(process.env.NODE_ENV=='local'){
//          host = 'http://adsvc.imcoming.com.cn'
//        }else if(process.env.NODE_ENV=='development'){
//          host = 'http://adsvc.imcoming.com.cn'
//        }else if(process.env.NODE_ENV=='test'){
//          host = 'http://adsvc.imcoming.com'
//        }else{
//          // host = 'https://adsvc.anlaiye.com'
//          host = 'https://adsvc.anlaiye.com.cn'
//        }
        url = host+'/ad/app/getList.do'
        // console.log(url)
        var params = {
          app_version: "5.3",
          client_type: 3,
          device_id: "123",
          time: new Date().getTime(),
          schoolId: _this.schoolInfo.schoolId,
          locationId: "118"
        }
        _this.$http.post(url, params).then(function (response) {
          _this.banners = response.data.data.list;
          if(_this.banners.length>0) {
            _this.$nextTick(function () {
              var mySwiper = new Swiper('.swiper-container',{
                pagination : '.pagination'
              });
              var bannerWidth = document.body.scrollWidth;
              var bannerHeight = (bannerWidth*8)/25;
              document.getElementById('banner1').style.height = bannerHeight + 'px';
            })
          }
          // 响应成功回调
        }, function (response) {
          // _this.alert(response.message)
          // 响应错误回调
        })
      },
      bannerJump: function (data){
        if( data != '{}'){
          var bannerJump = JSON.parse(data)
          window.location.href = bannerJump.url
        }
      },
      getShopList: function () {
        var _this = this;
        _this.hasMore = false;
        var params = {
          school_id: _this.schoolInfo.schoolId,
          page: _this.currentPage,
          pageSize: _this.pageSize
        };
        // 获取当前校区商家列表
        actions.getShopList(_this, params, function (data) {
          _this.showPage = true;
          if(data && data.length > 0){
            if(data.length < _this.pageSize) {
              _this.hasMore = false
            } else {
              _this.hasMore = true
            }
            _this.currentPage = _this.currentPage +1;
            for(let shop of data){
              let obj = {
                backgroundImage: "url("+shop.pic+")"
              }
              shop.backgroundimg = obj;
              shop.isShowAll = false;
              _this.currentShopList.push(shop)
            }
          } else {
            _this.hasMore = false
          }
        })
      },
      chooseSchool:function () {
        this.$router.push({path:`/chooseschool`})
      },
      toGoodsList: function (id, name) {
        var _this = this;
        var obj = {
          shop_code: id,
          shop_name: name,
          showBlockType: 'orderDishes'
        };
        _this.$store.commit('changeState', obj);
        _this.$router.push({name:'GoodsList'})
      },
      toSearch: function () {
        var _this = this;
        _this.$router.push({name: 'Search'})
      },
      toShopList: function (id, name) {
        var _this = this;
        var obj = {
          category_code: id,
          category_name: name,
          shopListType: 'category'
        }
        _this.$store.commit('changeState', obj);
        _this.$router.push({name:'ShopList'})
      },
      toggleShowMore: function (item) {
        var _this = this
        for(var key in _this.currentShopList) {
          if(_this.currentShopList[key].id == item.id) {
            _this.currentShopList[key].isShowAll = !_this.currentShopList[key].isShowAll
          }
        }
      }
    },
    components: {
      CommentStars
    }
  }
</script>



// WEBPACK FOOTER //
// HomePage.vue?b134763a